export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9446.8a734121.jpg";